// NetworkStatus.jsx
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const NetworkStatus = ({ setNetworkStatusVar }) => {
  const {t, i18n } = useTranslation();
  useEffect(() => {
    const handleOnline = () => {
      setNetworkStatusVar('online');
      showToast('success','NetworkStatus.Online');
    };

    const handleOffline = () => {
      setNetworkStatusVar('offline');
      showToast('error','NetworkStatus.Offline');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setNetworkStatusVar]);

  const showToast = (type, messageKey) => {
    const position = i18n.language === 'ar' ? 'top-left' : 'top-right';
    const id = `network-${type}`;

    toast.dismiss(); // Dismiss any previous toasts
    toast[type](t(messageKey), {
      position,
      toastId: id,
    });
  };

  useEffect(() => {
const checkSpeed = () => {
  const start = performance.now();
  const img = new Image();

  img.onload = () => {
    const duration = performance.now() - start;
    if (duration > 1000) {
      // toast.warn(t('NetworkStatus.SlowInternet'));
      showToast('warn', 'NetworkStatus.SlowInternet');
      setNetworkStatusVar('slow');
    } else {
      setNetworkStatusVar('online');
    }
  };

  img.onerror = () => {
    showToast('error','NetworkStatus.SlowOrOffline');
    setNetworkStatusVar('offline');
  };

  // Use a reliable small image with no CORS issues
  // img.src = `https://gamizign.co:8000/uploads/2025-07-14-07-21-14-032845.JPG`
  // img.src = `${process.env.REACT_APP_ENDPOINT}/uploads/2025-07-14-07-05-21-833670.JPG`
  img.src = 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Placeholder_view_vector.svg?' + new Date().getTime();
};


    const interval = setInterval(checkSpeed, 15000);
    return () => clearInterval(interval);
  }, [setNetworkStatusVar]);

  return null;
};

export default NetworkStatus;
